import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { TestLeftMenu, TestProvider } from '../../../test/providers/test-provider';
import { forkJoin, from, Observable, Subscription } from 'rxjs';
import { TestRights } from '../../../test/providers/test-rights';
import { ConfigProvider } from "../../../config-provider.service";
import { Title } from '@angular/platform-browser';
import { CurrentUser } from '../../../common/providers/current-user';
import { CurrentUserRolesProvider } from '../../../organizations/providers/current-user-roles-provider';
import { ActivatedRoute } from '@angular/router';
import { LangsProvider } from '../../../common/providers/langs-provider';
import { BreadcrumbProvider } from '../../../breadcrumb/providers/breadcrumb-provider';
import { UsersProvider } from '../../../users/providers/users-provider';
import { TranslateService } from '@ngx-translate/core';
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { Organization } from "../../../common/models/organization";
import { User } from "../../../common/models/user";
import { Test } from "../../../common/models/test";
import { Athlete } from "../../../common/models/athlete";
import {
  TestMultiLineBorgChartComponent
} from "../../../test/components/multi-line-borg-chart/test-multi-line-borg-chart";
import { ModuleContentComponent } from "../../../common/components/module-content/module-content";
import { AsyncPipe, NgIf } from "@angular/common";
import { MobileTestSideMenuComponent } from "../side-menu/mobile.side-menu";
import { MobileSideMenuComponent } from "../../../common/components/mobile-side-menu/mobile.side-menu.component";
import { MobileHeaderComponent } from "../../../common/components/mobile-header/mobile.header";
import { MobilePageContentComponent } from "../../../common/components/mobile-page-content/mobile-page-content";

@Component({
  selector: 'app-mobile--all-test-container',
  templateUrl: './mobile.all-test-container.component.html',
  styleUrls: ['./mobile.all-test-container.scss'],
  imports: [
    TestMultiLineBorgChartComponent,
    ModuleContentComponent,
    NgIf,
    MobileTestSideMenuComponent,
    MobileSideMenuComponent,
    MobileHeaderComponent,
    MobilePageContentComponent,
    AsyncPipe
  ],
  standalone: true
})
export class MobileAllTestContainerComponent implements OnInit, AfterViewInit, OnDestroy {

    public pageTitle = 'Tests';
    public isLoading = true;
    public is401 = false;
    public is404 = false;

    public graphClass = 'test-multi-line-chart';

    public organization: Organization = {} as Organization;
    public athleteUser: User = {} as User;
    public tests: Test[] = [];
    public testsLeftMenu: TestLeftMenu[] = [];
   public data: any;

    public rights: TestRights = new TestRights(this.utils);
    private subscriptions: Subscription[] = [];

    constructor(
        public conf: ConfigProvider,
        private title: Title,
        private utils: UtilsProvider,
        private currentUserRoles: CurrentUserRolesProvider,
        private route: ActivatedRoute,
        private testProvider: TestProvider,
        private langsProvider: LangsProvider,
        private userProvider: UsersProvider,
        private changeDetector: ChangeDetectorRef,
        private translator: TranslateService,
    ) {
    }

    public ngOnInit(): void {
        // Load athlete and annual plan if it exists
        this.subscriptions.push(
            this.route.data.subscribe((data: any) => {//{ organization: Organization; athlete: Athlete; test: Test }
                this.organization = data.organization;
                this.athleteUser = data.athlete;

                this.loadData();
            })
        );
    }

    public ngAfterViewInit(): void {
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public loadData() {

        forkJoin(([
          this.testProvider.findAllWithMaxDate(this.organization, this.athleteUser, this.langsProvider.getBestLangId()),
          this.testProvider.getAllMeasures(
            this.organization,
            this.athleteUser.athlete!,
          ),
        ])).subscribe(([testsLeftMenu, measures]) => {
            this.testsLeftMenu = testsLeftMenu;
            this.data = measures
            this.changeDetector.detectChanges();
        });

        this.rights.evaluateScreenRights({
            rolesIds: this.currentUserRoles.getRolesIds(this.organization.id!)
        });
        if (!this.rights.LIST) {
            this.is401 = true;
        }

        this.createPageTitle();
        this.isLoading = false;
    }

    public updateSideMenuEvent() {
        this.isLoading = true;
        this.loadData();
    }

    private createPageTitle() {
        this.pageTitle = this.translator.instant('TestsAll');
        this.title.setTitle(this.pageTitle + ' | ' + this.conf.platformName);
    }
}
